<template>
  <div>
    <b-row>
      <b-col md="3">
        <b-form-group
          label="Company"
        >
          <custom-v-select
            id="party"
            v-model="selectedParties"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="partyOptions"
            label="text"
            placeholder="Select Company"
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="Status"
        >
          <custom-v-select
            v-model="selectedStatusOption"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="statusOptions"
            label="text"
            placeholder="Select Option"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Post"
        >
          <custom-v-select
            v-model="selectedPostOption"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="postOptions"
            label="text"
            placeholder="Select Option"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  VBTooltip, BRow, BCol, BFormGroup,
} from 'bootstrap-vue'
import axios from 'axios'
import CustomVSelect from '@/components/UI/CustomVSelect.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    CustomVSelect,
  },
  data() {
    return {
      partyOptions: [],
      selectedParties: [],
      selectedStatusOption: [],
      selectedPostOption: [],
      statusOptions: [
        { text: 'Active', value: 'active' },
        { text: 'InActive', value: 'inactive' },
      ],
      postOptions: [
        { text: 'Medical Representative', value: 'Medical Representative' },
        { text: 'Area Manager', value: 'Area Manager' },
        { text: 'Regional Manager', value: 'Regional Manager' },
        { text: 'Zonal Manager', value: 'Zonal Manager' },
        { text: 'Business Head', value: 'Business Head' },
      ],
    }
  },
  created() {
    this.fetchOptions()
  },
  beforeDestroy() {
    // Clean up timer when component is destroyed
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  },
  methods: {
    fetchOptions() {
      axios.get('/company_options')
        .then(res => {
          this.partyOptions = res.data.data
        })
    },
    filtersChangeHandler() {
      const filtersdata = {}
      if (this.selectedParties) {
        filtersdata.company = this.selectedParties.id
      }
      if (this.selectedStatusOption.value === 'active') {
        filtersdata.is_active = 'True'
      } else if (this.selectedStatusOption.value === 'inactive') {
        filtersdata.is_active = 'False'
      }
      if (this.selectedPostOption) {
        filtersdata.post = this.selectedPostOption.value
      }

      this.$emit('filtersUpdated', filtersdata)
    },
  },
}
</script>
